import { render } from "./VanillaG.vue?vue&type=template&id=79e6047c&scoped=true"
import script from "./VanillaG.vue?vue&type=script&lang=js"
export * from "./VanillaG.vue?vue&type=script&lang=js"

import "./VanillaG.vue?vue&type=style&index=0&id=79e6047c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e6047c"]])

export default __exports__